import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d971745c")

_pushScopeId("data-v-d971745c")
const _hoisted_1 = { class: "skeleton-desktop-view-only" }
const _hoisted_2 = { class: "loading-video main-video-skeleton" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  class: "loading-svg-icon shaka-big-play",
  viewBox: "0 0 61 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("rect", {
    width: "61",
    height: "61",
    rx: "12",
    fill: "#ccc"
  }),
  /*#__PURE__*/_createVNode("path", {
    fill: "#fff",
    d: "M22 21.5763C22 19.5799 24.1634 18.3445 25.8688 19.367L40.752 28.2906C42.416 29.2884 42.416 31.7115 40.752 32.7092L25.8688 41.633C24.1635 42.6555 22 41.4201 22 39.4237L22 21.5763Z"
  })
], -1)
const _hoisted_4 = { class: "loading-message" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "video-holder" }, [
  /*#__PURE__*/_createVNode("div", { class: "loading-moment-box" }, [
    /*#__PURE__*/_createVNode("svg", {
      class: "loading-rect-icon",
      viewBox: "0 0 1000 185",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createVNode("rect", {
        width: "1000",
        height: "185"
      })
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GridSkeleton = _resolveComponent("GridSkeleton")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.loadingmsg), 1)
      ]),
      _hoisted_5
    ]),
    _createVNode(_component_GridSkeleton, {
      loadingmsg: _ctx.loadingmsg,
      class: `skeleton-mobile-view-only`
    }, null, 8, ["loadingmsg"])
  ]))
})